import React from 'react';
import { Link } from 'react-router-dom';
import { useUserForm } from '../../context/UserFormContext';
export default function CreateUserHeader() {
  const { isEditing, id, formData, saving, submitDisabled, canManage } = useUserForm();
  return <header className="mb-6 flex flex-col gap-4 border-b border-slate-100 bg-white px-6 py-5 sm:flex-row sm:items-center sm:justify-between">
    <div><nav aria-label="Breadcrumb" className="mb-2 flex flex-wrap gap-2 text-xs text-slate-500">
      <Link to="/users" className="hover:text-indigo-600">Users</Link><span>/</span>
      {isEditing && <><Link to={'/users/' + id} className="hover:text-indigo-600">User Details</Link><span>/</span></>}
      <span>{isEditing ? 'Edit User' : 'Create User'}</span></nav>
      <h1 className="text-2xl font-bold text-slate-900">{isEditing ? 'Edit User' : 'Create New User'}</h1>
      <p className="mt-1 text-sm text-slate-500">{isEditing ? 'Update ' + (formData.fullName || 'this user') + '’s profile and access.' : 'Add a user profile and assign an account role.'}</p>
    </div>
    <div className="flex gap-3"><Link to={isEditing ? '/users/' + id : '/users'} className="rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50">Cancel</Link>
      {canManage && <button type="submit" form="user-profile-form" disabled={submitDisabled} className="rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50">
        {saving ? 'Saving...' : isEditing ? 'Save Changes' : 'Create User'}</button>}
    </div>
  </header>;
}
